'use client';

import Link from 'next/link';

export default function AnchorLink({
  href,
  children,
  className,
}: {
  href: string;
  children: React.ReactNode;
  className?: string;
}) {
  const handleClick = (e: React.MouseEvent) => {
    const [path, hash] = href.split('#');

    if (typeof window !== 'undefined') {
      if (window.location.pathname === path && hash) {
        e.preventDefault();

        const el = document.querySelector(`#${hash}`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <Link href={href} onClick={handleClick} className={className}>
      {children}
    </Link>
  );
}